import { Link } from "react-router";
import { useServices, useSync } from "../app/services";
import { Icon } from "../components/Icon";
import { NowPlayingCard, PlayerControls, QueueList, ViewerStatus } from "../components/player";
import { PageHeader } from "../components/ui";
import { playerCondition } from "../lib/playerStatus";
import { WelcomeGuide } from "../components/WelcomeGuide";

/**
 * いま聴く：再生状態・紹介文・キュー・自分の参加状態と、再生操作・ここ好き・キュー管理。
 * 音は Discord の VC で流れる。このページは音を出さない
 */
export function NowPage() {
  const sync = useSync();
  const { sync: controller } = useServices();
  const cond = playerCondition(sync);
  const showBanner = cond.tone !== "ok" && cond.kind !== "paused" && cond.kind !== "connecting" && !!sync.playback?.current;
  const stale = sync.conn === "stale" || sync.conn === "reconnecting";
  const hasMix = !!sync.playback?.mix;

  return (
    <div className={`page page--now${hasMix ? " page--now-mix" : ""}`}>
      <PageHeader title="いま聴く" stage />

      {stale && (
        <div className="notice notice--warn notice--stale" role="status">
          <Icon name="wifiOff" className="notice__icon" />
          <div>
            <p className="notice__title">更新停止中{sync.conn === "reconnecting" ? "（つながり直しています…）" : ""}</p>
            <p>{cond.detail}</p>
            <button
              type="button"
              className="btn btn-secondary btn-small notice__action"
              onClick={() => controller.reconnectNow()}
              disabled={sync.conn === "reconnecting"}
            >
              <Icon name="refresh" className="btn-icon" />
              いますぐつなぎ直す
            </button>
          </div>
        </div>
      )}
      {!stale && showBanner && (
        <div className={`notice notice--${cond.tone === "danger" ? "danger" : cond.tone === "warn" ? "warn" : "info"}`} role="status">
          <Icon name={cond.icon} className="notice__icon" />
          <div>
            <p className="notice__title">{cond.title}</p>
            {cond.detail && <p>{cond.detail}</p>}
          </div>
        </div>
      )}

      <NowPlayingCard />
      <ViewerStatus />
      <PlayerControls />
      <QueueList />
      <WelcomeGuide />

      <p className="section-more">
        <Link to="/history" className="btn btn-ghost btn-small">
          <Icon name="history" className="btn-icon" />
          これまでに流れた曲（履歴）
        </Link>
      </p>
    </div>
  );
}
